/* eslint-disable */
import {Elements, ExpressCheckoutElement, useStripe} from "@stripe/react-stripe-js";
import React, {useEffect, useState} from "react";
import {loadStripe} from "@stripe/stripe-js";
import {paypalService} from "../../../api/payPal";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');


const PayPalElement = ({priceId, secondPrice, intentSecret, email, name, planName }: {
    priceId: string,
    secondPrice:string,
    intentSecret: string,
    email: string,
    name: string,
    planName: string,
}) => {
        const [setupIntentInfo, saveSetupIntentInfo] = useState<any>();

        useEffect(() =>{
            paypalInitiate()
        }, [])

    const paypalInitiate = async () => {

        try{
            const result = await paypalService.paypalCustomer({ email, name })

            localStorage.setItem('customerId', result.customerId)
            localStorage.setItem('paymentMethodId', result.payment_method)
            localStorage.setItem('priceId', priceId)
            localStorage.setItem('secondPriceId', secondPrice )
            localStorage.setItem('userEmail', email)
            localStorage.setItem('subscriptionPlan', planName)
            saveSetupIntentInfo(result)
        }catch(e){
            // alert('error ' + e)
        }

    }

    return <div>
        {setupIntentInfo && setupIntentInfo.client_secret &&
            <Elements stripe={stripePromise} options={{ clientSecret: intentSecret }}>
                <PaypalButton setupIntentInfo={setupIntentInfo} />
            </Elements>
        }

    </div>
}

const PaypalButton = ({ setupIntentInfo }: {setupIntentInfo: any}) => {
    const stripe = useStripe()


    const finishSetup = async () => {
        try{
            if (setupIntentInfo && setupIntentInfo.client_secret) {
                const result = await stripe?.confirmPayPalSetup(
                    setupIntentInfo.client_secret,
                    {
                        return_url: `${process.env.REACT_APP_FUNNEL_URL}/subscription/paypal-success`,
                        mandate_data: {
                            customer_acceptance: {
                                type: 'online',
                                online: {
                                    infer_from_client: true
                                }
                            }
                        },
                    }
                );
            }
        }catch(error){
            alert('Message with error: ' + error)
        }
    }


    return <ExpressCheckoutElement
        onClick={finishSetup}
        options={{
            buttonType: {
                paypal: 'pay',
                applePay: 'buy',
                googlePay: 'buy'
            },
            buttonHeight: 45,
            buttonTheme: {
                applePay: 'black',
                googlePay: 'black',
                paypal: 'gold',
            },
            paymentMethodOrder: ['paypal', 'googlePay', 'applePay'],
        }}
        onReady={({availablePaymentMethods}) => {
            console.log('is available methods ', availablePaymentMethods)
        }}
        onConfirm={async (event) => {
            // Handle express checkout confirmation
            console.log('Express checkout confirmed:', event);
            // You can add your payment processing logic here
        }}
        onLoadError={event => {
            console.log("Event ", event)
        }}
    />
}

export default PayPalElement
